import React, { useEffect, useState } from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FormikSelect } from '../../../components';
import { delayMethod } from '../../../services/utils';
import { indexShiftsRequest } from '../../../requests/shifts';

const AttendanceUpdateShiftForm = props => {
  const { errors, touched, setFieldValue, handleModalClose, onHide, isSubmitting, setFieldTouched, attendance } = props;
  const dispatch = useDispatch();
  const [shifts, setShifts] = useState([]);

  const fetchContractShift = () => {
    indexShiftsRequest({
      dispatch,
      params: {
        active: true,
        sort_column: 'name',
        paginate: false,
        serializer: 'basic_selector'
      },
      successCallback: response => {
        const { data } = response.data;
        setShifts(data);
      }
    });
  };

  useEffect(fetchContractShift, []);

  return (
    <Form>
      <Modal.Body>
        <Row>
          <Col md={12} className="d-grid">
            <span>
              <b>Trabajador:</b> {attendance.name}
            </span>
            <span>
              <b>Rut:</b> {attendance.nationalIdentification}
            </span>
            <span>
              <b>Fecha:</b> {attendance.date}
            </span>
          </Col>

          <Col md={12} className="mt-2">
            <Field name="attendance[shiftId]">
              {({ field }) => (
                <FormikSelect
                  {...field}
                  abbr
                  label="Turno"
                  placeholder="Seleccionar Turno"
                  options={shifts}
                  defaultValue={attendance.shift.id}
                  onChange={data => setFieldValue(field.name, data ? data.value : '')}
                  setFieldTouched={() => setFieldTouched(field.name)}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button className="text-center" variant="outline-info" onClick={() => delayMethod(handleModalClose)}>
          Cancelar
        </Button>
        <Button type="submit" variant="primary" onClick={onHide} disabled={isSubmitting}>
          Guardar
        </Button>
      </Modal.Footer>
    </Form>
  );
};

const setInitialValues = props => {
  const { attendance } = props;
  const { arrival, departure, arrivalBreakTime, departureBreakTime, shift, date } = attendance;
  const allIds = [
    ...(arrival ? arrival.map(item => item.id) : []),
    ...(departure ? departure.map(item => item.id) : []),
    ...(arrivalBreakTime ? arrivalBreakTime.map(item => item.id) : []),
    ...(departureBreakTime ? departureBreakTime.map(item => item.id) : [])
  ];

  return {
    attendance: {
      shiftId: shift?.id,
      attendanceIds: allIds,
      employeeId: attendance.employeeId,
      date,
      oldShiftId: shift?.id
    }
  };
};

const validationSchema = Yup.object().shape({
  attendance: Yup.object().shape({
    shiftId: Yup.string().required('Debes seleccionar un turno')
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: true,
  validateOnMount: false
})(AttendanceUpdateShiftForm);
